angular.module('trainerWebApp.resources').factory('UsersCtrlResolver',
  ['$q', '$route', 'usersResource', 'Validation', '$location', 'errorHandler', 'Auth', function ($q, $route, usersResource, Validation, $location, errorHandler, Auth) {

    return function () {
      var deferred = $q.defer();
      var pageName = $route.current.params.pageName || $route.current.pageName;
      var userId = $route.current.params.userId;

      var successCb = function (result) {
        Auth.getRolePromise().then(function () {
          if (userId) {
            if (angular.isArray(result) && angular.equals(result, [])) {
              deferred.reject("No user found by that id.");
            } else {
              deferred.resolve(result);
            }
          } else {
            deferred.resolve(result);
          }
        });
      };

      // let the controller handle the validate
      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      if (!pageName || pageName == 'manageUsers') {
        usersResource.getSetupForManageUsers(successCb, errorHandler.defaultServerErrorHandler());
      }

      if (pageName == 'addNewUser') {
        usersResource.getAddUserSetupForManage(successCb, errorHandler.defaultServerErrorHandler());
      }

      return deferred.promise;
    };
  }]
);
